var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"columns":_vm.columns,"row-key":function (record) { return record.objId; },"data-source":_vm.data,"pagination":_vm.pagination,"loading":_vm.loading,"size":"middle"},on:{"change":_vm.handleTableChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04925082","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/memberManagement/playRecord/playRecordContent.vue
// module id = null
// module chunks = 